import { render, staticRenderFns } from "./uploadSOI.vue?vue&type=template&id=6beb8d9e"
import script from "./uploadSOI.vue?vue&type=script&lang=js"
export * from "./uploadSOI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports